import { t } from '@lingui/macro';
import { Api } from 'api';
import { FormControlFormSelect, FormControlFormSelectProps } from 'core';
import React from 'react';
import { useQuery } from 'react-query';
import { VehicleQueryCacheKeys } from 'types';

export type VehicleColorSelectProps = FormControlFormSelectProps;
export const VehicleColorSelect: React.FC<VehicleColorSelectProps> = ({ ...formSelectProps }) => {
  const query = useQuery(
    VehicleQueryCacheKeys.GetVehicleColors,
    async () => {
      const response = await Api.Vehicle.getColors();
      return response.data;
    },
    {
      refetchOnWindowFocus: false,
    },
  );
  return (
    <FormControlFormSelect label={t`Arac Rengi`} placeholder={t`Arac Rengi`} {...formSelectProps}>
      {query.data?.map((color) => (
        <option value={color.key} key={`vcs${color.value}`}>
          {color.value}
        </option>
      ))}
    </FormControlFormSelect>
  );
};
